import { render, staticRenderFns } from "./UpgradeFeature.vue?vue&type=template&id=1417c42d&scoped=true"
import script from "./UpgradeFeature.vue?vue&type=script&lang=js"
export * from "./UpgradeFeature.vue?vue&type=script&lang=js"
import style0 from "./UpgradeFeature.vue?vue&type=style&index=0&id=1417c42d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1417c42d",
  null
  
)

export default component.exports